
export let URL_API = window.publicConfig.URL_API;
export let USE_COLOR = window.publicConfig.USE_COLOR;
export let LOGIN_NOTE = window.publicConfig.LOGIN_NOTE;
export let TIMEOUT = window.publicConfig.TIMEOUT;
export let ENABLE_VIEW_SIGNED_FILE = window.publicConfig.ENABLE_VIEW_SIGNED_FILE;
